import { takeEvery, fork, put, all } from "redux-saga/effects";

// Messages Redux States
import { VG_START_SIGNALR_CONN, VG_STOP_SIGNALR_CONN } from "./actionTypes";
import { vgStartedConnection, vgStoppedConnection, vgFailedConnection } from "./actions";

function* vgStartConnection({
  payload: {
    connection,
  },
}) {


  try {


    yield connection.start();

    yield put(vgStartedConnection(connection, connection.connectionState));
    return connection;
  } catch (error) {
    console.log(error);
    yield put(vgFailedConnection(connection, connection.connectionState));
  }
}

function* vgStopConnection({
  payload: {
    connection,
  },
}) {


  try {


    yield connection.stop();

    yield put(vgStoppedConnection(connection));
    return connection;
  } catch (error) {
    console.log(error);
  }
}

export function* watchStartConn() {
  yield takeEvery(VG_START_SIGNALR_CONN, vgStartConnection);
}
export function* watchStopConn() {
  yield takeEvery(VG_STOP_SIGNALR_CONN, vgStopConnection);
}

function* authSaga() {
  yield all([fork(watchStartConn), fork(watchStopConn)]);
}

export default authSaga;
